<mee-table
  [builder]="tableBuilder"
  [minWidth]="1000"
></mee-table>
